const Home = () => {
  return (
    <span style={{display:'none'}}></span>
  );
};

export default Home;
